export default () => ({
  products: {},
  carousel: {},
  product: null,
  productInv: null,
  filters: {
    attributes: [],
    countries: [],
    regions: [],
    availability: [],
    productTypes: [],
  },
});
